import "./NotificationNavbar.css";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { IoMdNotificationsOff, IoMdNotificationsOutline  } from "react-icons/io";
import Form from "react-bootstrap/Form";
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { db, deleteElement, getCollection, getDocument } from "../../Firebase";
import { collection, doc, onSnapshot, query, where } from "firebase/firestore";
import { SamaDate } from "../../Services";

function NotificationNavbar() {
  const [show, setShow] = useState(false);
  const [notificationn, setNotificationn] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const curentUserId = sessionStorage.getItem("user_id");

  useEffect(() => {
    getNotification();
  }, []);

  const getNotification = () => {
    const refNotif = query(
      collection(db, "notification"),
      where("notificationFOr", "==", curentUserId)
    );
    let data = [];
    onSnapshot(refNotif, (item) => {
      item.forEach((i) => {
        const { notificationBy, message, createdOn } = i.data();
        onSnapshot(doc(db, "users", notificationBy), (doc) => {
          const titre = `${doc.data().prenom} ${doc.data().nom}`;
          data.push({ titre, message, createdOn, id: i.id });
          setNotificationn(data);
        });
      });
    });
  };

  return (
    <Dropdown className="dropnotif" as={ButtonGroup}>
      <Dropdown.Toggle id="dropdown-custom-1">
        <div className="notifIcon">
          <IoMdNotificationsOutline className="apled" />
          <div className="nmbrNot">
            <p className="fw-bold ">{notificationn.length}</p>
          </div>
        </div>
      </Dropdown.Toggle>
      {notificationn.length === 0 ?  <Dropdown.Menu className="text-secondary px-3">
        <div className="text-center fs-1"><IoMdNotificationsOff /></div>
        <h3>Aucune notification</h3>
      </Dropdown.Menu> :
        <Dropdown.Menu className="dropNmenu">
          <h3 className="text-center fx-bold">Notification</h3>
          {notificationn.map((not, index) => {
            return (
              <Dropdown.Item eventKey={index} key={index}>
                {/* <div className="drapdown-content"  eventKey={index}> */}
                <h4>{not.titre}</h4>
                <p className="message-notif">{not.message}</p>
                <button
                  className="text-primary text-end text-decoration-underline border-0 bg-transparent"
                  onClick={handleShow}
                >
                  Voir plus
                </button>
                <p className="text-muted">
                  {<SamaDate mydate={not?.createdOn} />}
                </p>
                {/* </div> */}
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>{not?.titre}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <p className="">{not?.message}</p>
                    <p className="text-muted">
                      {<SamaDate mydate={not?.createdOn} />}
                    </p>
                  </Modal.Body>
                  <Modal.Footer>
                    {/* <Button variant="secondary" onClick={handleClose}>
                 Close
               </Button> */}
                    <Button
                      variant="danger"
                      onClick={() =>
                        deleteElement("notification", not?.id).then(handleClose())
                      }
                    >
                      Supprimer
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      }

    </Dropdown>
  );
}

export default NotificationNavbar;
